module.exports = __webpack_public_path__ + "static/media/icon.bca6d6f4.png";